import { URLBuilderLink } from 'lib/url/url-builder-link';
import { displayedName } from 'four-nets/user/utils';

export class UserBazaarLink extends (URLBuilderLink as { new (options: object): any }) {
    constructor(options: { user: { username: string; name?: string } }) {
        const { user } = options;

        super({
            label: displayedName(user),
            url: 'bazaar/user',
            value: {
                username: user.username,
            },
        });
    }
}
